import {ChangeDetectionStrategy, Component, Input, OnDestroy} from '@angular/core'
import {Subject} from 'rxjs'
import {TranslocoModule} from '@ngneat/transloco'
import {FilterModule} from '../../../craft/filter/filter.module'
import {CommonModule} from '@angular/common'
import {ProDirectoryModule} from '../pro-directory/pro-directory.module'
import {ButtonModule} from '../../../craft/button/button.module'
import {SortingModule} from '../../../craft/sorting/sorting.module'
import {MessageModule} from '../../../craft/message/message.module'
import {RouterLink} from '@angular/router'
import {CardsModule} from '../../../craft/cards/cards.module'
import {OpenContactModalOnClickDirective} from '../../directives/open-contact-modal/open-contact-modal.directive'
import {Region} from '../../../core/content/types/craftsmen-region-types'

@Component({
  selector: 'bgo-pro-directory-by-region-section',
  templateUrl: './pro-directory-by-region-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FilterModule,
    SortingModule,
    ProDirectoryModule,
    ButtonModule,
    MessageModule,
    CardsModule,
    RouterLink,
    OpenContactModalOnClickDirective,
    TranslocoModule,
  ],
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class ProDirectoryByRegionSectionComponent implements OnDestroy {
  @Input({required: true}) region!: Region
  @Input() industryId?: number

  protected total = 0

  private unsubscribe$ = new Subject<void>()

  ngOnDestroy(): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }
}
